import React, { Component } from 'react';
import {TextInput, SelectInput} from './FormInputs.js';
import './basicforms.css';

class AddNewCoffeeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(id, value) {
    this.setState({
      [id]:value
    });
  }

  handleSubmit(event) {

    event.preventDefault();
    this.props.dbRef.add(
      this.state
    )
    .then(docRef => {
      console.log(docRef);
      this.props.onSave(docRef);
      //console.log('An offer was written with id: ' + docRef);
    })
    .catch(error => {
      console.log(error);
    });
  }

  render() {
    const grades = ['7.00','7.25','7.50','7.75','8.00','8.25','8.5','8.75','9.00'];
    const checks = ['10','8','6','4','2','0'];
    //const deliveryDates = ["10-Oct-2018","10-Jan-2019"];


    return (



	<form className='basicforms' onSubmit={this.handleSubmit}>

		<div className='form_container'>
    	<h3>{this.props.name}</h3>
      <div className="row">
				<div className="col-25">
					<label>Total Score</label>
				</div>
				<div className="col-75">

				</div>
	    </div>

  		<div className="row">
				<div className="col-25">
					<label>Fragrance/Aroma</label>
				</div>
				<div className="col-75">
  					<SelectInput selectItems={grades} dataId="fragrance" value={this.state.fragrance} handleChange={this.handleChange}  />
				</div>
	    </div>
			<div className="row">
				<div className="col-25">
					<label>Flavor</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={grades} dataId="flavor" value={this.state.flavor} handleChange={this.handleChange}  />
				</div>
	    </div>
	    <div className="row">
				<div className="col-25">
					<label>Aftertaste</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={grades} dataId="aftertaste" value={this.state.aftertaste} handleChange={this.handleChange}  />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Acidity</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={grades} dataId="acidity" value={this.state.acidity} handleChange={this.handleChange}  />
				</div>
      </div>
			<div className="row">
				<div className="col-25">
					<label>Body</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={grades} dataId="body" value={this.state.body} handleChange={this.handleChange}  />
				</div>
	    </div>
			<div className="row">
				<div className="col-25">
					<label>Balance</label>
				</div>
				<div className="col-75">
		        <SelectInput selectItems={grades} dataId="balance" value={this.state.balance} handleChange={this.handleChange}  />
				</div>
	    </div>
			<div className="row">
				<div className="col-25">
					<label>Overall</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={grades} dataId="overall" value={this.state.overall} handleChange={this.handleChange}  />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Uniformity</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={checks} dataId="uniformity" value={this.state.uniformity} handleChange={this.handleChange}  />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Clean Cup</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={checks} dataId="cleanCup" value={this.state.cleanCup} handleChange={this.handleChange}  />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Sweetness</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={checks} dataId="sweetness" value={this.state.sweetness} handleChange={this.handleChange}  />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Defects</label>
				</div>
				<div className="col-75">
					<TextInput type="number" dataId="defects"  value={this.state.defects} handleChange={this.handleChange} />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Observations</label>
				</div>
				<div className="col-75">
					<TextInput type="text" dataId="obs"  value={this.state.obs} handleChange={this.handleChange} />
				</div>
	    </div>


  		<div className="row">
  			<div className="col-100">
  				<input type="submit" value="Submit"/>
  			</div>
	    </div>


		</div>

      </form>

    );
  }
}

export default AddNewCoffeeForm;



// WEBPACK FOOTER //
// ./src/components/AddNewCoffeeForm.js